module.exports = __webpack_public_path__ + "static/media/recipe-book.9624282c.png";